import React from "react";

import { Spinner } from "@common/components/Spinner/Spinner";
import { useSessionReplay } from "@main/pages/shared/components/SessionReplayContainer/useSessionReplay";

import * as Styled from "./SessionReplayContainer.styles";

interface SessionReplayContainerProps {
  sessionReplayUrl: string;
}

export const SessionReplayContainer = ({ sessionReplayUrl }: SessionReplayContainerProps) => {
  const { loading, replayContainerRef } = useSessionReplay(sessionReplayUrl);

  return (
    <Styled.SessionReplayContainer>
      {loading ? <Spinner /> : <div ref={replayContainerRef}>{/* This is where the replay will be rendered */}</div>}
    </Styled.SessionReplayContainer>
  );
};
